// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__T0KqP","footer":"ModalUpdate_footer__288nT"};